module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1043-16a142115f63f46e831648c6459d1c2c.png";